<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-private-equity`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M25 1.577l17.919 10.346a2 2 0 011 1.732v20.69a2 2 0 01-1 1.732L25 46.423a2 2 0 01-2 0L5.081 36.077a2 2 0 01-1-1.732v-20.69a2 2 0 011-1.732L23 1.577a2 2 0 012 0zM24 5.62L8.081 14.81v18.382L24 42.38l15.919-9.19V14.809L24 5.62zm-1.661 10.95C21.22 15.524 19.448 15 17.019 15H11v18h3.986v-5.856h1.716c1.83 0 3.278-.29 4.343-.871s1.826-1.347 2.284-2.297c.457-.95.686-1.98.686-3.089 0-1.83-.559-3.269-1.676-4.316zM37 15v4.006h-6.959V22h6.477v4.015h-6.477v2.989H37V33H26V15h11zm-22.014 3.274h1.822c2.112 0 3.168.915 3.168 2.745 0 1.003-.33 1.73-.99 2.178-.66.449-1.553.673-2.68.673h-1.32v-5.596z"/></svg>
</template>
<script>

export default {
  name: 'IconPrivateEquity',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
